import type { FC, PropsWithChildren } from "react";

import { toast } from "@jti/core-components/components/Toaster";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { checkoutV2Slice } from "@jti/store/slices/checkoutV2Slice";
import { useTranslations } from "@jti/ui";

import { SubscriptionBillingDisclaimer } from "@checkout-v2/shared";
import { useCheckoutSubscriptionDisplayState } from "@checkout-v2/shared/hooks";

import styles from "./ConsentAndPaySection.module.scss";

export const ConsentAndPaySection: FC<PropsWithChildren> = ({ children }) => {
  const { __ } = useTranslations();
  const dispatch = useDispatch();

  const checkoutData = useSelector((state) => state.checkoutV2.data);
  const sectionState = useSelector((state) => state.checkoutV2.sectionsState.orderConfirmationSection);

  const { showConsentAndPaySubscriptionBillingDisclaimer } = useCheckoutSubscriptionDisplayState();

  const returnToPaymentSection = () => {
    dispatch(
      checkoutV2Slice.actions.setSectionsState({
        shippingSection: "completed",
        paymentSection: "active",
        orderConfirmationSection: "rested",
      })
    );
  };

  if (!checkoutData?.paymentMethodCode) {
    if (sectionState === "editing") {
      toast.error(__("cart.checkout.consent_and_pay.error.no_payment_method_selected"));
    }

    returnToPaymentSection();

    return null;
  }

  return (
    <div className={styles.container}>
      {showConsentAndPaySubscriptionBillingDisclaimer && <SubscriptionBillingDisclaimer />}

      <>{children}</>
    </div>
  );
};
